import { badgeColorData } from '@/components/atom/Badge';
import { RecyclingRequestStatus } from '@/src/models/RecyclingRequestDto';

export const getStatusBadgeProps = (
  status: RecyclingRequestStatus,
): {
  children: string;
  badgeColor: keyof typeof badgeColorData;
} => {
  switch (status) {
    case 'REQUEST':
      return {
        children: '수거 신청',
        badgeColor: 'lightYellow',
      };
    case 'PROCESSING':
      return {
        children: '수거중',
        badgeColor: 'lightGreen',
      };
    case 'SHIPPING':
      return {
        children: '수거완료',
        badgeColor: 'lightBlue',
      };
    case 'CANCELED_BY_CUSTOMER':
      return {
        children: '수거취소 - 고객 취소',
        badgeColor: 'lightRed',
      };
    case 'CANCELED_BY_CARRIER':
      return {
        children: '수거취소 - 택배사 취소',
        badgeColor: 'lightRed',
      };
    case 'CANCELED_BY_ADMIN':
      return {
        children: '수거취소 - 관리자 취소',
        badgeColor: 'lightRed',
      };
    case 'COMPLETED':
      return {
        children: '배달완료',
        badgeColor: 'lightGray',
      };
    case 'PARTIAL_COMPLETE':
      return {
        children: '부분 수거완료',
        badgeColor: 'lightBlue',
      };
    case 'SHIPPING_DELAYED':
      return {
        children: '미배달',
        badgeColor: 'lightRed',
      };
    case 'PROCESS_DELAYED':
      return {
        children: '미집하',
        badgeColor: 'lightRed',
      };
    default:
      return {
        children: '-',
        badgeColor: 'lightGray',
      };
  }
};
